import React from 'react';
import { FormComponentProps } from 'antd/es/form';
import { BookingType } from 'utilities/enum-utils';
import _ from 'lodash';
import { Modal } from '@good/ui/core';
import { Address } from '@good/schemas';
import { AssignWorkerBookingInline } from './assign-worker-booking-inline';
import { OnSubmitAssign } from './types';
import { ISession } from 'interfaces/session-interfaces';

interface AssignWorkerBookingModalProps extends FormComponentProps {
  address?: Address;
  bookingId?: string;
  bookingRequestId?: string;
  bookingType: BookingType;
  customerUserIds?: string[];
  displayTimezone?: string;
  endDateTime?: Date;
  isAssignedTeamMemberConfirmed?: boolean;
  isBookingCancelled: boolean;
  isEditingBooking?: boolean;
  isOpen: boolean;
  isRecurring?: boolean;
  noValidationStep?: boolean;
  onClose: (refreshData?: boolean) => void;
  onSubmitAssign: OnSubmitAssign;
  serviceId: string;
  sessions?: ISession[];
  startDateTime?: Date;
}

export const AssignWorkerBookingModal = ({ onClose, isOpen, ...props }: AssignWorkerBookingModalProps) => {
  return (
    <Modal maxHeight='100%' title='' hideFooter opened={isOpen} onClose={onClose} size='lg'>
      <AssignWorkerBookingInline onReset={onClose} {...props} />
    </Modal>
  );
};
